import React from "react";
import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined";
import PropTypes from "prop-types";
import { Videocam, Stars } from "@mui/icons-material";
import { achievementTypes } from "../../constants";
import CheckIcon from "./CheckIcon";
import WebinarIcon from "./WebinarIcon";
import IltIcon from "./IltIcon";
import PolicyIcon from "./PolicyIcon";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  icon: {
    verticalAlign: "middle",
    "& > svg": {
      overflow: "visible"
    }
  }
}));

function AchievementTypeIcon(props) {
  const classes = useStyles();
  const { size, color } = props;
  const iconProps = {
    fontSize: size,
    color,
    className: classes.icon
  };
  function createAchievementIcon(activityType) {
    const activity = activityType.toLowerCase();
    switch (activity) {
      case achievementTypes.webinar.toLowerCase():
        return <WebinarIcon {...iconProps} />;
      case achievementTypes.ilt.toLowerCase():
      case achievementTypes.instructorLedTraining.toLowerCase():
        return <IltIcon {...iconProps} />;
      case achievementTypes.virtual.toLowerCase():
        return <Videocam {...iconProps} />;
      case achievementTypes.video.toLowerCase():
      case achievementTypes.online.toLowerCase():
      case achievementTypes.onlineCourse.toLowerCase():
        return <DesktopMacOutlinedIcon {...iconProps} />;
      case achievementTypes.oldMysteryShopCompletion.toLowerCase():
      case achievementTypes.other.toLowerCase():
        return <Stars {...iconProps} />;
      case achievementTypes.validate.toLowerCase():
        return <CheckIcon {...iconProps} />;
      case achievementTypes.policy.toLowerCase():
        return <PolicyIcon {...iconProps} />;
      default:
        return null;
    }
  }

  return props.type ? createAchievementIcon(props.type) : null;
}

export default AchievementTypeIcon;

AchievementTypeIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string
};

AchievementTypeIcon.defaultProps = {
  fontSize: "default",
  color: "action"
};
